module.exports = __webpack_public_path__ + "img/logo_stanovak.527f0d5b.svg";